import Banner from '@zenbusiness/zui/Banner';
import SharedAsset from '@zenbusiness/zui/SharedAsset';

import { CARD_STATUS } from '#client/constants/cards';
import { MODAL_NAMES } from '#client/constants/modals';
import useCardsContext from '#client/hooks/useCardsContext';
import useModalContext from '#client/hooks/useModalContext';
import { BannerWrapperStyled } from '#client/pages/SharedStyles';
import { getDiffTime } from '#client/utils/date';

export default function SuspectedFraudCardBanner() {
  const { physicalCard, cardsError, cardsLoading } = useCardsContext();
  const { openModal } = useModalContext();

  const diffDay = Math.abs(getDiffTime(physicalCard?.updatedAt, 'h'));

  const isSuspectedFraudCard = physicalCard?.status === CARD_STATUS.SUSPECTED_FRAUD;
  const isShowFrozenBySuspectedFraudBanner = isSuspectedFraudCard && diffDay < 24;
  const isShowCancelBySuspectedFraudBanner = isSuspectedFraudCard && diffDay >= 24;

  if (cardsError) {
    return null;
  }

  if (cardsLoading) {
    return undefined;
  }
  if (isShowFrozenBySuspectedFraudBanner) {
    return (
      <BannerWrapperStyled>
        <Banner
          slots={{
            startIcon: (
              <SharedAsset
                alt=""
                src="/icon/micro/info-circle-alt.svg"
                width={26}
              />
            )
          }}
          subtitle="Investigations are usually resolved in 24 hours. You’ll then be able to order a new card, if needed."
          title="Your physical debit card is frozen while suspected fraud is being investigated."
          variant="alert"
        />
      </BannerWrapperStyled>
    );
  }

  return isShowCancelBySuspectedFraudBanner ? (
    <BannerWrapperStyled>
      <Banner
        slotProps={{
          primaryAction: {
            label: 'Order replacement',
            onClick: () => {
              openModal({
                name: MODAL_NAMES.CREATE_NEW_CARD_MODAL
              });
            }
          }
        }}
        slots={{
          startIcon: (
            <SharedAsset
              alt=""
              src="/icon/micro/info-circle-alt.svg"
              width={26}
            />
          )
        }}
        subtitle="Order a new card anytime under “cards” or use your virtual card."
        title="Your physical debit card has been cancelled due to suspected fraud"
        variant="alert"
      />
    </BannerWrapperStyled>
  ) : null;
}
